module.exports = __webpack_public_path__ + "img/card_bottom.3312a0d2.png";